import React, { useState, useEffect } from "react";
import { fetchWithAuth } from "../../Context/UserContext";
import PageLayout from "../../components/layout/PageLayout";
import { TopProgressBar } from "../../components/ui/progress-bar";
import FiltroLicitaciones from "./FiltroLicitaciones";
import InfoLicitaciones from "./InfoLicitaciones";
import API_URL from "../../config";
import { Helmet } from "react-helmet-async";
import { toast } from "sonner";

const Licitaciones = () => {
  console.log("entrando a licitaciones");
  const [tenders, setTenders] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResults, setTotalResults] = useState(0);
  const [isLoading, setIsLoading] = useState(false); // Estado de carga
  const [filters, setFilters] = useState({
    categoria: [], // Permite múltiples categorías
    ciudad: [], // Permite múltiples ciudades
    condiciones_pago: [], // Permite múltiples condiciones
    duracion_contrato: [], // Un solo valor permitido
    fecha: "", // Permite múltiples fechas
  });

  useEffect(() => {
    fetchTenders(page, filters);
  }, [page, filters]);

  const fetchTenders = async (page, filters) => {
    setIsLoading(true);
    console.log("enviar", filters);

    try {
      const params = new URLSearchParams({
        page,
        ...(filters.categoria.length > 0 && {
          categoria: filters.categoria.map((cat) => cat.trim()).join(","), // Convertir a string plano
        }),
        ...(filters.ciudad.length > 0 && { ciudad: filters.ciudad.join(",") }),
        ...(filters.condiciones_pago.length > 0 && {
          condiciones_pago: filters.condiciones_pago.join(","),
        }),
        ...(filters.duracion_contrato.length > 0 && {
          duracion_contrato: filters.duracion_contrato.join(","),
        }), // Cambiado a manejar múltiples valores
        ...(filters.fecha && { fecha: filters.fecha }), // Cambiado para un string
      });

      const response = await fetchWithAuth(
        `${API_URL}/licit/get_tenders?${params.toString()}`,
        { public: true }
      );

      if (response.ok) {
        const { tenders, pages, total } = await response.json();
        console.log(
          "Archivos de cada tender:",
          tenders.map((tender) => tender.files)
        );
        setTenders(tenders);
        setTotalPages(pages);
        setTotalResults(total);
      } else {
        console.error("Error al obtener las licitaciones", response.statusText);
        toast.error("No se pudieron cargar las licitaciones. Intenta de nuevo.");
      }
    } catch (error) {
      console.error("Error al obtener las licitaciones", error);
      toast.error("No se pudieron cargar las licitaciones. Intenta de nuevo.");
    } finally {
      setIsLoading(false);
    }
  };

  console.log(tenders);

  return (
    <PageLayout>
      <Helmet>
        <title>Explora Licitaciones - Procu</title>
        <meta
          name="description"
          content="Descubre licitaciones activas en Procu. Encuentra oportunidades de negocio y conecta con empresas en nuestra plataforma B2B."
        />
        <meta name="keywords" content="licitaciones, oportunidades, negocios, proveedores, contratos, Procu, B2B" />
      </Helmet>

      <TopProgressBar isLoading={isLoading} />

      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6">
        <FiltroLicitaciones
          filters={filters}
          setFilters={setFilters}
          onClearFilters={() => {
            setFilters({
              categoria: [],
              ciudad: [],
              condiciones_pago: [],
              duracion_contrato: [], // Array vacío para múltiples valores
              fecha: "", // String vacío para un solo valor
            });
            setPage(1);
          }}
        />
        <InfoLicitaciones
          tenders={tenders}
          page={page}
          totalPages={totalPages}
          totalResults={totalResults}
          setPage={setPage}
        />
      </div>
    </PageLayout>
  );
};

export default Licitaciones;
